/**
 * Project Models
 * Task projects for grouping and organizing tasks
 */

// ==================== Project Models ====================

export interface ProjectResponse {
  id: number;
  group_id?: number;
  name: string;
  description?: string;
  color?: string;
  linked_entity_type?: string;
  linked_entity_id?: string;
  metadata?: { [key: string]: any };
  is_active: boolean;
  created_at: string;
  created_by?: number;
  updated_at: string;
  updated_by?: number;
  closed_at?: string;
  closed_by?: number;
}

export interface ProjectWithStatsResponse extends ProjectResponse {
  total_tasks: number;
  open_tasks: number;
  completed_tasks: number;
  overdue_tasks: number;
}

export interface CreateProjectRequest {
  group_id?: number;
  name: string;
  description?: string;
  color?: string;
  linked_entity_type?: string;
  linked_entity_id?: string;
  metadata?: { [key: string]: any };
  is_active?: boolean;
}

export interface UpdateProjectRequest {
  name?: string;
  description?: string;
  color?: string;
  is_active?: boolean;
}

// ==================== Project Access Models ====================

export enum ProjectAccessRole {
  VIEWER = 'viewer',
  CONTRIBUTOR = 'contributor',
  ADMIN = 'admin',
  OWNER = 'owner'
}

export interface GrantProjectAccessRequest {
  user_id?: number;
  group_id?: number;
  role: ProjectAccessRole;
}

export interface UpdateProjectAccessRequest {
  role: ProjectAccessRole;
}

export interface ProjectAccessResponse {
  id: number;
  project_id: number;
  user_id?: number;
  group_id?: number;
  role: string;
  added_at: string;
  added_by: number;
  // Optional populated fields
  user_email?: string;
  group_name?: string;
  access_type?: 'user' | 'group';
}

export interface ProjectAccessListResponse {
  project_id: number;
  project_name: string;
  access_grants: ProjectAccessResponse[];
}

export interface UserProjectAccessResponse {
  user_id: number;
  projects: UserAccessibleProjectResponse[];
}

export interface UserAccessibleProjectResponse {
  project_id: number;
  project_name: string;
  role: string;
  access_type: 'direct' | 'group' | 'owner';
  group_name?: string;
}

// ==================== Helper Types ====================

export interface ProjectOption {
  value: number;
  label: string;
  color?: string;
  isActive: boolean;
}

export interface ProjectStats {
  totalProjects: number;
  activeProjects: number;
  totalTasks: number;
  completionRate: number;
}
